// app-user · search form, results, filters (Design Part 1, rows 2–3). Spread into
// en.ts / bn.ts. Chrome strings the handoff already carries live in app-strings.ts
// (`app.search.*`); everything added here is new copy for real data (counts, areas,
// suggestions, errors) with no demo names or places.
export const appEnSearch = {
  'app.search.close': 'Close',
  'app.search.chip.doctor': 'Doctor',
  'app.search.chip.clinic': 'Clinic',
  'app.search.chip.salon': 'Salon',
  'app.search.chip.turf': 'Turf',
  'app.search.chip.hotel': 'Hotel',
  'app.search.chip.dining': 'Dining',
  'app.search.chip.events': 'Events',
  'app.search.chip.gym': 'Gym',
  'app.search.chip.classes': 'Classes',
  'app.search.back': 'Back',
  'app.search.clear': 'Clear',
  'app.search.allAreas': 'All areas',
  'app.search.chooseArea': 'Choose area',
  'app.search.kind.business': 'Business',
  'app.search.kind.category': 'Category',
  'app.search.kind.area': 'Area',
  'app.search.kind.professional': 'Professional',
  'app.search.tmrw': 'Tmrw',
  'app.search.window.all': 'All day',
  'app.search.window.morning': '6–12',
  'app.search.window.afternoon': '12–5',
  'app.search.window.evening': '5–10',
  'app.search.locating': 'Finding your area…',
  'app.search.locDenied': 'Location is off. Choose an area instead.',
  'app.search.locFar': 'We could not match your location to an area.',
  'app.search.resultsCount': '{n, plural, one{# result found} other{# results found}}',
  'app.search.filtersN': 'Filters · {n}',
  'app.search.minRatingChip': 'Minimum {r}+',
  'app.search.availToday': 'Available today',
  'app.search.showN': '{n, plural, one{Show # result} other{Show # results}}',
  'app.search.sortRelevance': 'Recommended',
  'app.search.sortPriceDesc': 'Highest fee',
  'app.search.feeUnder': 'Under {max}',
  'app.search.feeBetween': '{min}–{max}',
  'app.search.feeOver': '{min}+',
  'app.search.emptyBodyArea': 'Nothing matches these filters in {area}.',
  'app.search.emptyBodyAll': 'Nothing matches these filters.',
  'app.search.emptyBodyCatArea': 'No {what} match these filters in {area}.',
  'app.search.emptyBodyCat': 'No {what} match these filters.',
  'app.search.noun.doctor': 'doctors',
  'app.search.noun.clinic': 'clinics',
  'app.search.noun.salon': 'salons',
  'app.search.noun.hotel': 'hotels',
  'app.search.noun.turf': 'turfs',
  'app.search.noun.restaurant': 'restaurants',
  'app.search.noun.event': 'events',
  'app.search.noun.venue': 'venues',
  'app.search.noun.class': 'classes',
  'app.search.noun.gym': 'gyms',
  'app.search.noun.consult': 'consultants',
  'app.search.noun.photo': 'photo studios',
  'app.search.noun.cowork': 'co-working spaces',
  'app.search.noun.rentals': 'rental services',
  'app.search.errorTitle': 'We could not load results',
  'app.search.errorBody': 'Check your connection and try again.',
  'app.search.mapNote': 'The map is not available yet. Places are listed as pins.',
  'app.search.searchOffline': 'You are offline. Connect to search.',
  'app.search.moreLoading': 'Loading more…',
  'app.search.moreError': 'We could not load more results.',
  'app.search.showResults': 'Show results',
} as const satisfies Record<string, string>;

export const appBnSearch = {
  'app.search.close': 'বন্ধ করুন',
  'app.search.chip.doctor': 'ডাক্তার',
  'app.search.chip.clinic': 'ক্লিনিক',
  'app.search.chip.salon': 'সেলুন',
  'app.search.chip.turf': 'টার্ফ',
  'app.search.chip.hotel': 'হোটেল',
  'app.search.chip.dining': 'ডাইনিং',
  'app.search.chip.events': 'ইভেন্ট',
  'app.search.chip.gym': 'জিম',
  'app.search.chip.classes': 'ক্লাস',
  'app.search.back': 'পেছনে',
  'app.search.clear': 'মুছুন',
  'app.search.allAreas': 'সব এলাকা',
  'app.search.chooseArea': 'এলাকা বেছে নিন',
  'app.search.kind.business': 'ব্যবসা',
  'app.search.kind.category': 'ক্যাটাগরি',
  'app.search.kind.area': 'এলাকা',
  'app.search.kind.professional': 'পেশাজীবী',
  'app.search.tmrw': 'আগামীকাল',
  'app.search.window.all': 'সব সময়',
  'app.search.window.morning': '৬–১২টা',
  'app.search.window.afternoon': '১২–৫টা',
  'app.search.window.evening': '৫–১০টা',
  'app.search.locating': 'আপনার এলাকা খোঁজা হচ্ছে…',
  'app.search.locDenied': 'লোকেশন বন্ধ আছে। এলাকা বেছে নিন।',
  'app.search.locFar': 'আপনার লোকেশনের সাথে কোনো এলাকা মেলেনি।',
  'app.search.resultsCount': '{n}টি ফলাফল পাওয়া গেছে',
  'app.search.filtersN': 'ফিল্টার · {n}',
  'app.search.minRatingChip': 'ন্যূনতম {r}+',
  'app.search.availToday': 'আজ খালি আছে',
  'app.search.showN': '{n}টি ফলাফল দেখুন',
  'app.search.sortRelevance': 'প্রস্তাবিত',
  'app.search.sortPriceDesc': 'সর্বোচ্চ ফি',
  'app.search.feeUnder': '{max}-এর নিচে',
  'app.search.feeBetween': '{min}–{max}',
  'app.search.feeOver': '{min}+',
  'app.search.emptyBodyArea': '{area}-এ এই ফিল্টারে কিছু মেলেনি।',
  'app.search.emptyBodyAll': 'এই ফিল্টারে কিছু মেলেনি।',
  'app.search.emptyBodyCatArea': '{area}-এ এই ফিল্টারে কোনো {what} নেই।',
  'app.search.emptyBodyCat': 'এই ফিল্টারে কোনো {what} নেই।',
  'app.search.noun.doctor': 'ডাক্তার',
  'app.search.noun.clinic': 'ক্লিনিক',
  'app.search.noun.salon': 'সেলুন',
  'app.search.noun.hotel': 'হোটেল',
  'app.search.noun.turf': 'টার্ফ',
  'app.search.noun.restaurant': 'রেস্টুরেন্ট',
  'app.search.noun.event': 'ইভেন্ট',
  'app.search.noun.venue': 'ভেন্যু',
  'app.search.noun.class': 'ক্লাস',
  'app.search.noun.gym': 'জিম',
  'app.search.noun.consult': 'পরামর্শদাতা',
  'app.search.noun.photo': 'ফটো স্টুডিও',
  'app.search.noun.cowork': 'কো-ওয়ার্কিং স্পেস',
  'app.search.noun.rentals': 'ভাড়া সেবা',
  'app.search.errorTitle': 'ফলাফল লোড করা যায়নি',
  'app.search.errorBody': 'ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।',
  'app.search.mapNote': 'ম্যাপ এখনো পাওয়া যায় না। জায়গাগুলো পিন হিসেবে তালিকায় দেখানো হলো।',
  'app.search.searchOffline': 'আপনি অফলাইনে আছেন। খুঁজতে ইন্টারনেটে যুক্ত হন।',
  'app.search.moreLoading': 'আরও লোড হচ্ছে…',
  'app.search.moreError': 'আরও ফলাফল লোড করা যায়নি।',
  'app.search.showResults': 'ফলাফল দেখুন',
} as const satisfies Record<string, string>;
